import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sprout, Moon } from "lucide-react";
import api from "@/lib/api";
import Pulse from "@/components/forest/Pulse";
import TreeVisual from "@/components/garden/TreeVisual";
import CountUp from "@/components/motion/CountUp";
import { useSite } from "@/contexts/SiteContext";

/*
 * Banda „Organismul viu" pe homepage: Inima (puls) + invitația în Pădure +
 * Respirăm Împreună. Fraza-busolă a conceptului.
 */
export default function ForestBand() {
  const { sectionContent } = useSite();
  const c = sectionContent("forest_band") || {};
  const [total, setTotal] = useState(null);
  useEffect(() => {
    api.get("/public/forest").then((r) => setTotal(r.data.total_trees)).catch(() => {});
  }, []);

  return (
    <section data-testid="forest-band" className="py-16 sm:py-24" style={{ background: "linear-gradient(180deg, var(--ct-bg) 0%, var(--ct-surface) 100%)" }}>
      <div className="max-w-5xl mx-auto px-5 lg:px-8 text-center">
        <div className="flex items-end justify-center gap-2 mb-6 opacity-90">
          <TreeVisual stage={3} season="primavara" size={64} showBird={false} />
          <TreeVisual stage={5} season="vara" size={96} />
          <TreeVisual stage={6} season="toamna" size={78} showBird={false} />
        </div>

        <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Organismul viu al vindecării"}</span>
        <h2 data-el="title" data-field="title" className="font-serif text-3xl sm:text-4xl lg:text-5xl mt-3 leading-tight max-w-2xl mx-auto">
          {c.title || "Fiecare om care se vindecă e un copac care crește. Împreună, suntem o pădure."}
        </h2>
        {total != null && total >= 5 && (
          <p className="text-base mt-4" style={{ color: "var(--ct-text-muted)" }}>
            În pădure cresc acum <strong style={{ color: "var(--ct-link)" }}><CountUp value={total} /></strong> copaci. Nu ești singur(ă).
          </p>
        )}
        {total != null && total > 0 && total < 5 && (
          <p className="text-base mt-4" style={{ color: "var(--ct-text-muted)" }}>
            Pădurea abia a răsărit — primii copaci cresc deja. Al tău poate fi următorul.
          </p>
        )}

        <div className="my-8"><Pulse /></div>

        <div className="flex flex-wrap gap-3 justify-center">
          <Link to="/padurea" className="btn-gold" data-testid="forestband-forest"><Sprout size={16} /> <span data-field="enter_label">{c.enter_label || "Intră în Pădure"}</span></Link>
          <Link to="/respiram" className="btn-outline-gold" data-testid="forestband-breathe"><Moon size={16} /> <span data-field="breathe_label">{c.breathe_label || "Respirăm Împreună — duminică 21:00"}</span></Link>
        </div>
      </div>
    </section>
  );
}
